import isErrorDocument from './isErrorDocument'
import isResourceCollectionDocument from './isResourceCollectionDocument'
import isResourceDocument from './isResourceDocument'

export default {
    isErrorDocument,
    isResourceCollectionDocument,
    isResourceDocument,
}
